




























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import {
  PossibleExpense,
  ExpenseRecurringType,
  ExpenseCategory,
  ExpenseEligibility
} from "@/shared/types";

import EditExpenseForm from "@/shared/components/expenseV2/EditExpenseForm.vue";
import Widget from "@/shared/components/Widget.vue";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: {
    EditExpenseForm,
    Widget,
    Button
  }
})
export default class HealthcareExpensesAdd extends Vue {

  @Prop({ required: false })
  claim: any; // Claim

  @Prop({ required: false })
  addClaimLink: boolean;

  ExpenseEligibility = ExpenseEligibility;

  expense = {
    id: null,
    name: "",
    amount: 0,
    comment: "",
    expensePaid: false,
    recurringType: ExpenseRecurringType.OneTime,
    expenseStatus: ExpenseEligibility.Eligible,
    expenseCategory: "other"
  };
  confirmPaid = false;

  onConfirmPaid () {
    this.confirmPaid = true;
  }

  onConfirmUnpaid () {
    this.confirmPaid = false;
  }

  handleSubmit () {
    this.$parent.$emit("close-add-expense");
  }
}

